import { makeStyles } from '@material-ui/core/styles';
import {imageBackground, pattern_all} from '../../values';

export const useStyles = makeStyles(theme => ({
    text:{
        color:'white',
        cursor:'auto',
        fontFamily:'Book',
    },
    titleBanner:{
        color:'white',
        cursor:'auto',
        fontSize:45,
        marginLeft:50,
        fontFamily:'Heavy',
    },
    phone:{
        [theme.breakpoints.up('xl')]: {
            width:300, 
            height:'auto'
        },
        [theme.breakpoints.down('lg')]: {
            width:200, 
            height:'auto'
        },
        [theme.breakpoints.down('xs')]: {
            width:100, 
            height:'auto'
        },
    },
    backgroundHome:{
        height:'calc(100vh - 210px)', 
        display:'flex', 
        alignItems:'center',
        background:'black',
        backgroundImage:`url(${pattern_all})`,
        backgroundRepeat:'repeat',
        backgroundSize: '100px',
    },
    logo:{
        [theme.breakpoints.up('xl')]: {
            width:200
        },
        [theme.breakpoints.down('lg')]: {
            width:150, 
        },
        [theme.breakpoints.down('xs')]: {
            width:100, 
        },
    },
    banner:{
        height:150, 
        display:'flex', 
        alignItems:'center',
        background:'black',
        backgroundImage:`url(${pattern_all})`,
        backgroundRepeat:'repeat',
        backgroundSize: '80px',
    },
    inputArea:{
        border:'1px solid black',
        borderRadius:0,
        height:150,
        width:'100%',
        background:'white',
        padding:10,
        fontSize:16,
        marginBottom:10,
        resize:'none',
        fontFamily:'Book',
        marginTop:10,
    },
    input1:{
        border:'1px solid black',
        borderRadius:0,
        width:'calc(100% - 10px)',
        background:'white',
        fontFamily:'Book',
        fontSize:16,
        paddingLeft:10,
        paddingTop:5,
        paddingBottom:5,
        marginLeft:20,
        marginTop:10,
        [theme.breakpoints.down('xs')]: {
            marginLeft:0,
            width:'calc(100% + 10px)',
        },
    },
    input2:{
        border:'1px solid black',
        borderRadius:0,
        width:'calc(100% - 10px)',
        background:'white',
        fontFamily:'Book',
        fontSize:16,
        paddingLeft:10,
        paddingTop:5,
        paddingBottom:5,
        marginTop:10,
        // marginLeft:20,
        [theme.breakpoints.down('xs')]: {
            marginLeft:0,
            width:'calc(100% + 10px)',
        },
    },
    button:{
        color:'white',
        cursor:'pointer',
        fontSize:16,
        paddingTop:7,
        paddingBottom:7,
        paddingLeft:35,
        paddingRight:35,
        background:'red',
        border:'none',
        transition:'0.3s ease',
        "&:hover":{
            transition:'0.1s ease',
            transform:'translateY(-5px)',
            boxShadow:'0px 5px 8px 0px rgba(0,0,0,0.5)',
        },
        "&:active":{
            transition:'0.1s ease',
            // transform:'scaleY(0.9) scaleX(1.1)',
            transform:'translateY(-2px)',
            boxShadow:'0px 2px 5px 0px rgba(0,0,0,0.5)'
        },
    },
    containerHome:{
        textAlign:'right',
        [theme.breakpoints.down('xs')]: {
            textAlign:'center',
        },
    },
    containerHome2:{
        height:'calc(100% - 100px)', 
        paddingLeft:50, 
        display:'flex', 
        alignItems:'center',
        [theme.breakpoints.down('xs')]: {
            paddingLeft:0,
            display:'block', 
            textAlign:'center',
        },
    },
    containerHome3:{
        background:'white', 
        borderRadius:7, 
        cursor:'pointer', 
        width:180,
        [theme.breakpoints.down('xs')]: {
            // width:'100%', 
            position:'absolute',
            left:'50%',
            transform:'translate(-50%, 0)'
        },
    },
    containerHome4:{
        display:'flex', alignItems:'center',paddingTop:3,paddingBottom:3,
        // [theme.breakpoints.down('xs')]: {
        //     width:'100%', 
        //     display:'block', 
        // },
    },
    containerHomeImage:{
        paddingRight:50,
        [theme.breakpoints.down('xs')]: {
            paddingRight:0,
        },
    },
    containerText:{
        width:250, 
        paddingTop:50,
        [theme.breakpoints.down('xs')]: {
            textAlign:'center',
            width:'100%', 
        },
    },
    containerPrivacy:{
        background:'black', 
        borderBottom:'1px solid silver', 
        height:'calc(100vh - 441px)',
        [theme.breakpoints.down('xs')]: {
            height:'100%',
        },
    },
    containerContact:{
        background:'black', 
        borderBottom:'1px solid silver', 
        height:'calc(100vh - 441px)', 
        display:'flex', 
        alignItems:'center',
        [theme.breakpoints.down('xs')]: {
            height:'100%',
            paddingBottom:100,
            paddingTop:100,
        },
    },
    contactLine:{
        borderRight:'13px solid black',
        [theme.breakpoints.down('xs')]: {
            borderRight:0
        },
    },
    space:{
        height:200,
        [theme.breakpoints.down('xs')]: {
            height:0,
        },
    },
    text1Contact:{
        paddingLeft:50,
        [theme.breakpoints.down('xs')]: {
            paddingLeft:10,
        },
    },
    containerContactInput:{
        padding:50, paddingTop:0, paddingBottom:0,
        [theme.breakpoints.down('xs')]: {
            paddingLeft:10,
            paddingRight:30
        },
    },
    containerContacForm:{
        padding:50, paddingTop:0,
        [theme.breakpoints.down('xs')]: {
            paddingLeft:10,
            paddingRight:30
        },
    },
    text2Contact:{
        marginLeft:20,
        [theme.breakpoints.down('xs')]: {
            marginLeft:0,
        },
    }
}))
